import { registerIconLibrary } from '@shoelace-style/shoelace';
import * as icons from 'lucide-static';

// Registriert die Lucide-Icons als "lucide"-Library für Shoelace
registerIconLibrary('lucide', {
    resolver: (name) => {
        const key = name
            .split('-')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join('');
        const icon = icons[key as keyof typeof icons];
        return icon ? `data:image/svg+xml;utf8,${encodeURIComponent(icon)}` : '';
    },
    mutator: (svg) => {
        svg.setAttribute('fill', 'currentColor');
        svg.setAttribute('stroke', 'currentColor');
    }
});